// src/context/InspectorAuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const InspectorAuthContext = createContext(null);

export function InspectorAuthProvider({ children }) {
  const [inspector, setInspector] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('inspectorUser');
    const token = localStorage.getItem('authToken');
    if (stored && token) {
      const user = JSON.parse(stored);
      if (user.role === 'inspector') {
        setInspector(user);
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('inspectorUser', JSON.stringify(userData));
    setInspector(userData);
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('inspectorUser');
    setInspector(null);
  };

  return (
    <InspectorAuthContext.Provider value={{ inspector, login, logout, loading }}>
      {children}
    </InspectorAuthContext.Provider>
  );
}

export const useInspectorAuth = () => useContext(InspectorAuthContext);